import React from 'react';
import Iframe from 'react-iframe';
import styles from './Checkout.module.css';

const Checkout = ({ episodeID, token }) => {

  return (
    <div className={styles.checkoutContainer}>
      <Iframe src={`https://www.paytr.com/odeme/guvenli/${token}`} id="paytriframe" frameborder="0"
        scrolling="yes" style={{width: 100 + '%'}} sandbox="allow-forms allow-pointer-lock allow-popups allow-same-origin allow-scripts" />
    </div>
  );
};

export default Checkout;